import { MutableRefObject, useEffect, useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { Feature } from 'geojson';
import mapboxgl from 'mapbox-gl';
import Modal from '../../basics/Modal';
import fitMapBounds from '../../../utils/fitMapBounds';
import {
  LandAdvisorModalBody,
  LandAdvisorModalFooter,
} from './LandAdvisorModal';

const ReplaceParcelsModal = ({
  pendingFeatures,
  setPendingFeatures,
  parcels,
  setParcels,
  mapRef,
}: {
  pendingFeatures: Feature[];
  setPendingFeatures: (features: Feature[]) => void;
  parcels: Feature[];
  setParcels: (features: Feature[]) => void;
  mapRef: MutableRefObject<mapboxgl.Map | null>;
}) => {
  const [replaceFeatures, setReplaceFeatures] = useState(false);
  const isOpen = !!parcels.length && !!pendingFeatures.length;
  const toggle = () => setPendingFeatures([]);

  useEffect(() => {
    // Reset to default option when opened
    setReplaceFeatures(false);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen && pendingFeatures.length) {
      setParcels(pendingFeatures);
      fitMapBounds({ mapRef, maxZoom: 15, features: pendingFeatures });
      setPendingFeatures([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, pendingFeatures]);

  const handleAction = () => {
    const updatedFeatures = replaceFeatures
      ? pendingFeatures
      : [...parcels, ...pendingFeatures];

    setParcels(updatedFeatures);
    fitMapBounds({ mapRef, maxZoom: 15, features: updatedFeatures });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <LandAdvisorModalBody>
        <div className="mb-3">Add to or replace existing parcels?</div>
        <FormGroup check className="d-flex align-items-center my-2">
          <Input
            type="radio"
            checked={!replaceFeatures}
            onChange={() => setReplaceFeatures(false)}
            id="add"
            className="mt-0"
          />
          <Label check htmlFor="add">
            Add to existing features
          </Label>
        </FormGroup>
        <FormGroup check className="d-flex align-items-center my-2">
          <Input
            type="radio"
            checked={replaceFeatures}
            onChange={() => setReplaceFeatures(true)}
            id="replace"
            className="mt-0"
          />
          <Label check htmlFor="replace">
            Replace existing features
          </Label>
        </FormGroup>
      </LandAdvisorModalBody>
      <LandAdvisorModalFooter>
        <Button color="secondary" onClick={toggle} size="sm">
          Cancel
        </Button>
        <Button color="primary" onClick={handleAction} size="sm">
          OK
        </Button>
      </LandAdvisorModalFooter>
    </Modal>
  );
};

export default ReplaceParcelsModal;
